<template>
  <v-card
    flat
    :color="drag_area_color"
    @dragleave.prevent="drag_area_color = null"
    @dragover.prevent="drag_area_color = 'grey lighten-1'"
    @drop.prevent="onDrop"
  >
    <div class="d-flex">
      <p class="mb-0">{{ set_upload_text() }}</p>
      <v-tooltip top v-if="upload_detail.additional">
        <template v-slot:activator="{ on }">
          <v-icon class="mb-1 ml-3" size="16" v-on="on">mdi-help-circle-outline</v-icon>
        </template>
        <span>{{ set_upload_subText() }}</span>
      </v-tooltip>
      <template v-if="'template' in upload_detail && upload_detail.template !== null">
        &nbsp;
        (<a :href="upload_detail.template.replace('{lang}', $i18n.locale)">
          {{ $t("message.upload.template") }}
        </a>)
      </template>
    </div>
    <v-file-input
      v-model="files"
      ref="files_input"
      :multiple="multiple"
      :label="this.$i18n.t('message.common.select_file')"
      :rules="[
        v => (multiple ? (v && v.length > 0) : !!v) || $t('message.upload.no_new_file'),
        v => (!multiple || (v && v.length <= max_files)) || $t('message.upload.over_files', { length: max_files })
      ]"
      :valid="valid"
      @change="$emit('update_files', multiple ? $event : (($event !== null) ? [$event] : []))"
      @update:error="$emit('update_files_valid', $event)"
    >
    </v-file-input>
    <v-dialog v-model="dialog" persistent max-width="80%">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>
            {{ $t("message.upload.uploading") }}
          </v-toolbar-title>
        </v-toolbar>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{ $t("message.upload.file_name") }}</th>
                <th class="text-left">{{ $t("message.common.progress") }}</th>
                <th class="text-left">{{ $t("message.common.status") }}</th>
                <th class="text-left">{{ $t("message.common.fid") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="upload in uploading_files" :key="upload.file_name">
                <td>{{ upload.file_name }}</td>
                <td>
                  {{ Math.round(10 * upload.progress) / 10 }}%
                  <v-progress-linear
                    :value="upload.progress"
                  ></v-progress-linear>
                </td>
                <td>{{ $t("message.upload.status_" + upload.status) }}</td>
                <td>
                  <template v-if="upload.fid !== ''">
                    {{ upload.fid }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
            <v-btn @click="cancel">
              {{ $t("message.common.cancel") }}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { http_error } from "../js/http_error";

export default {
  name: 'upload',
  props: {
    type: String,
    valid: Boolean,
    multiple: Boolean,
    max_files: Number,
    page: String,
    upload_detail: Object
  },
  mixins: [http_error],
  data: function(){
    return {
      module_id: "66",
      drag_area_color: null,
      files: null,
      dialog: false,
      uploading_files: [],
      cancel_token: null,
    }
  },
  methods: {
    onDrop: function(event){
      this.drag_area_color = null;
      var fileList = event.target.files ?
                     event.target.files:
                     event.dataTransfer.files;
      var files = [];
      var i = 0;
      for(var f of fileList){
        if(!this.multiple && i > 0){
          break;
        }
        files.push(f);
        i++;
      }
      if(this.multiple){
        this.files = files;
      }else{
        if(files.length > 0){
          this.files = files[0];
        }else{
          this.files = null;
        }
      }
      this.$emit('update_files', files);
    },
    upload: function(){
      this.uploading_files = [];
      this.cancel_token = this.$http.CancelToken.source();
      var files = this.files;
      if(!this.multiple){
        files = [this.files];
      }
      for(var file of files){
        var uploading_file = {
          "file_name": file.name,
          "progress": 0,
          "status": "uploading",
          "fid": null
        };
        var take_over = {
          "uploading_file": uploading_file,
          "parent": this
        }
        var formData = new FormData();
        formData.append('file', file);
        this.$http.post(this.$store.getters.api_endpoint + "/file?type=" + this.type,
                        formData,
                        {
                          headers: {
                            'Content-Type': 'multipart/form-data'
                          },
                          onUploadProgress: function( progressEvent ) {
                            this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                          }.bind(uploading_file),
                          cancelToken: this.cancel_token.token
                        })
          .then(function(response){
            this.status = "complete";
            this.progress = 100;
            this.fid = response.data.fid;
            this.cancel_token = null;
          }.bind(uploading_file) )
          .catch(function(error){
            this.uploading_file.status = "error";
            this.uploading_file.cancel_token = null;
            if(this.parent.http_error(error)){
              this.parent.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
              this.uploading_file.eid = error.response.data.eid
              this.uploading_file.param = error.response.data.param
            }
          }.bind(take_over) );
          this.uploading_files.push(uploading_file);
      }
      this.dialog = true;
    },
    cancel: function(){
      if(this.cancel_token){
        this.cancel_token.cancel();
        this.cancel_token = null;
        this.dialog = false;
        this.remove_range();
        this.$emit('done_upload', false);
      }
    },
    remove_range(){
      const selection = window.getSelection();
      if(selection.toString()){
        const range = selection.getRangeAt(0);
        selection.removeAllRanges(range);
      }
    },
    set_upload_text(){
      const description = !!this.page ? this.$i18n.t(`message.upload.drop_file_description_${this.upload_detail.target}`) : '';
      return this.$i18n.tc('message.upload.drop_file', this.upload_detail.files ,{ target: this.$i18n.t(`message.common.${this.upload_detail.target}`), multiple: this.upload_detail.files, target_description: description });
    },
    set_upload_subText(){
      const character_count = Number(this.upload_detail.count).toLocaleString();;
      return this.$i18n.tc('message.upload.drop_file_additional', this.upload_detail.files ,{ count: character_count, size: this.upload_detail.size , files: this.upload_detail.files });
    }
  },
  watch: {
    uploading_files: {
      handler: function (val, oldVal) {
        var is_complete = true;
        for(var file of val){
          if(!file.fid){
            is_complete = false;
            break;
          }
        }
        if(is_complete){
          this.dialog = false;
          this.$emit('done_upload', true);
        }
      },
      deep: true
    }
  }
}
</script>
